<template>
    <div class="stat-card" @click="viewDetail">
        <div class="stat-header">
            <div class="stat-icon">
                <!-- 如果是图片路径，则显示图片 -->
                <img v-if="isImage(icon)" :src="icon" alt="Icon" class="stat-icon-image" />
                <!-- 如果不是图片路径，则显示图标 -->
                <span v-else>{{ icon }}</span>
            </div>
            <div class="stat-trend" :class="trendClass">{{ trend }}</div>
        </div>
        <div class="stat-value">{{ value }}</div>
        <div class="stat-label">{{ label }}</div>
    </div>
</template>
<script>
export default {
    name: 'StatCard',
    props: {
        id: {
            type: Number,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        trend: {
            type: String,
            required: true,
        },
        trendClass: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },
    methods: {
        viewDetail() {
            this.$emit('view-detail', this.id);
        },
        isImage(url) {
            return url.endsWith('.png') || url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.gif') || url.endsWith('.svg');
        },
    },
};
</script>
<style scoped>
.stat-card {
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 1.5rem;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.stat-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(0, 255, 150, 0.1) 0%, transparent 70%);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
    border-color: rgba(0, 255, 150, 0.5);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.2);
}

.stat-card:hover::before {
    opacity: 1;
}

.stat-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1rem;
}

.stat-icon {
    width: 48px;
    height: 48px;
    background: var(--shade-color);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
}

.stat-icon-image {
    width: 100%;
    height: 100%;
    object-fit: cover; /* 确保图片填充整个区域 */
}

.stat-trend {
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.trend-up {
    color: #00ff96;
}

.trend-down {
    color: #ff6b6b;
}

.stat-value {
    font-size: 2rem;
    font-weight: bold;
    color: #00ff96;
    margin-bottom: 0.25rem;
}

.stat-label {
    color: #94a3b8;
    font-size: 0.9rem;
}
</style>